// extracted by mini-css-extract-plugin
export default {"pending":"VerificationStatusField_pending__5se+c","verified":"VerificationStatusField_verified__is5L4","rejected":"VerificationStatusField_rejected__5jWFd"};